import React from 'react';
import ClockIcon from './icons/clock';

const ListIntervals = ({ intervals, handleChange, classes, details }) => {
	const rules = {
		luni: [13, 18],
		marți: [10, 18],
		miercuri: [10, 18],
		joi: [10, 18],
		vineri: [10, 18],
		sâmbătă: [10, 17],
		duminică: [10, 13],
	};
	const dayRule = details.ziua
		? rules[details.ziua.split(/,| /)[0]]
		: rules['luni'];
	const formatHour = (hour) => {
		const h = Math.floor(hour);
		const m = (hour - h) * 60;
		return `${h.toString().padStart(2, '0')}:${m
			.toString()
			.padStart(2, '0')}`;
	};
	if (intervals.length > 0)
		return (
			<>
				<div className={classes['custom-form__iconDate']}>
					<ClockIcon />
					<span>Interval orar</span>
				</div>
				<div
					className={classes['custom-form__radio-hours-container']}
					onChange={handleChange}
				>
					{intervals
						.filter(
							(interval) =>
								interval >= dayRule[0] && interval < dayRule[1]
						)
						.map((interval, index, array) => {
							return (
								<div id={`radio${index}`} key={index}>
									<input
										className={classes['radio-hours-input']}
										type="radio"
										value={formatHour(interval)}
										name="ora"
										id={`radioHour${index}`}
									/>
									<label
										className={classes['radio-hours-label']}
										htmlFor={`radioHour${index}`}
									>
										{`${formatHour(
											interval
										)} - ${formatHour(interval + 1)}`}
									</label>
								</div>
							);
						})}
				</div>
			</>
		);
	else
		return (
			<h4>
				Ne pare rău, dar astăzi nu mai sunt intervale disponibile...
			</h4>
		);
};

export default ListIntervals;
